import { render, staticRenderFns } from "./twilio-send-email-input.vue?vue&type=template&id=546e2e39&scoped=true"
import script from "./twilio-send-email-input.vue?vue&type=script&lang=js"
export * from "./twilio-send-email-input.vue?vue&type=script&lang=js"
import style0 from "./twilio-send-email-input.vue?vue&type=style&index=0&id=546e2e39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546e2e39",
  null
  
)

export default component.exports